"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = exports.ModalBody = exports.ModalHeader = exports.ModalTitle = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const clsx_1 = require("clsx");
const eventUtils_1 = require("../common/eventUtils");
const icon_1 = require("../icon");
const __1 = require("..");
const prefix = 'tk-dialog';
const buildClass = (classStr) => `${prefix}__${classStr}`;
const ModalTitle = (_a) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.clsx)(buildClass('title'), className) }, rest, { children: children }));
};
exports.ModalTitle = ModalTitle;
const ModalHeader = (_a) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.clsx)(buildClass('header'), className) }, rest, { children: children }));
};
exports.ModalHeader = ModalHeader;
const ModalBody = (_a) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.clsx)(buildClass('body'), 'styled-scrollbars', className) }, rest, { children: children }));
};
exports.ModalBody = ModalBody;
const ModalFooter = (_a) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.clsx)(buildClass('footer'), className) }, rest, { children: children }));
};
exports.ModalFooter = ModalFooter;
const FOCUSABLE_ELEMENTS = 'button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])';
// Utility function to get focusable elements
const getFocusableElements = (container) => {
    return Array.from(container.querySelectorAll(FOCUSABLE_ELEMENTS));
};
// Focus trap handler
const handleTabKey = (event, modal) => {
    const focusableElements = getFocusableElements(modal);
    if (focusableElements.length === 0)
        return;
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    const realFocusableElements = focusableElements.filter(element => element.tabIndex !== -1);
    const realFistElement = realFocusableElements[0];
    const realLastElement = realFocusableElements[realFocusableElements.length - 1];
    if (event.key === eventUtils_1.Keys.TAB) {
        if (event.shiftKey && (document.activeElement === firstElement || document.activeElement === realFistElement)) {
            realLastElement.focus();
            event.preventDefault();
        }
        else if (!event.shiftKey && (document.activeElement === lastElement || document.activeElement === realLastElement)) {
            realFistElement.focus();
            event.preventDefault();
        }
    }
};
const Modal = (_a) => {
    var { size, className, children, closeButton, onClose, focusTrapEnabled = true, parentNode, show, ariaLabel } = _a, rest = __rest(_a, ["size", "className", "children", "closeButton", "onClose", "focusTrapEnabled", "parentNode", "show", "ariaLabel"]);
    let previousFocusedElement;
    const modalRef = React.useRef(null);
    const containerClasses = (0, clsx_1.clsx)(className, `${prefix}-backdrop`);
    const sizeClasses = (0, clsx_1.clsx)(prefix, { [`${prefix}--${size}`]: size });
    const handleContentClick = (event) => event.stopPropagation();
    const onMouseDown = (event) => event.stopPropagation();
    const handleKeyUp = (event) => {
        if (onClose && event.key === eventUtils_1.Keys.ESC) {
            event.stopPropagation();
            onClose();
        }
    };
    React.useEffect(() => {
        if (show && focusTrapEnabled) {
            // Keeps a reference to the element that had the focus before opening the Modal, restore it when we close the modal
            previousFocusedElement = document.activeElement;
            const trapFocus = () => {
                var _a;
                if (modalRef.current) {
                    const focusableElements = getFocusableElements(modalRef.current);
                    // Focus the first element if available
                    (_a = focusableElements[0]) === null || _a === void 0 ? void 0 : _a.focus();
                    // Add event listener for Tab key
                    const onKeyDown = (e) => handleTabKey(e, modalRef.current);
                    document.addEventListener(eventUtils_1.EventListener.keydown, onKeyDown);
                    // Cleanup event listener
                    return () => {
                        document.removeEventListener(eventUtils_1.EventListener.keydown, onKeyDown);
                        previousFocusedElement === null || previousFocusedElement === void 0 ? void 0 : previousFocusedElement.focus();
                    };
                }
            };
            const cleanup = trapFocus();
            return cleanup;
        }
    }, [show, focusTrapEnabled]);
    const domResult = ((0, jsx_runtime_1.jsx)("div", Object.assign({ onMouseDown: onMouseDown }, rest, { className: containerClasses, onClick: onClose, onKeyUp: handleKeyUp, tabIndex: -1, children: (0, jsx_runtime_1.jsxs)("div", { ref: modalRef, role: "dialog", "aria-label": ariaLabel, className: sizeClasses, onClick: handleContentClick, children: [closeButton && ((0, jsx_runtime_1.jsx)("button", { "aria-label": "close", className: (0, clsx_1.clsx)(buildClass('close'), className), onClick: onClose, type: "button", children: (0, jsx_runtime_1.jsx)(icon_1.SvgIcon, { icon: __1.Icons.Cross }) })), children] }) })));
    return show
        ? parentNode
            ? ReactDOM.createPortal(domResult, parentNode)
            : domResult
        : null;
};
exports.default = Modal;
